import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AsYouType } from 'libphonenumber-js'
import classNames from 'classnames'

import useForm from './useForm'
import { useList } from '../frankentangel'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'
import Button from './Button'

const SuggestionList = ({ suggestions, listLoading, setListLoading, setValue }) => {
  const [Paginator, results, _error, loading] = useList(suggestions.table, suggestions.action, suggestions.params || {}) // eslint-disable-line no-unused-vars

  if (loading !== listLoading) setTimeout(() => setListLoading(loading), 0)

  return (
    <div className='dropdown-content is-scrollable-clamped'>
      <Paginator>
        {
          results.filter(result => result.doc).map((result, index) => (
            <a // eslint-disable-line
              className='dropdown-item'
              key={index}
              onMouseDown={() => setValue(result.doc)}
              onTouchStart={() => setValue(result.doc)}
            >{result.doc}
            </a>
          ))
        }
      </Paginator>
    </div>
  )

  // return (
  //   <datalist id={datalistId}>
  //     {
  //       results.filter(result => result.doc).map((result, index) => (
  //         <option value={result.doc} key={index}>{result.doc}</option>
  //       ))
  //     }
  //   </datalist>
  // )
}

const FormInputField = props => {
  const { id, name, onBlur, onChange, placeholder, disabled, required, label, classes, type, iconLeft, phoneType, pattern, suggestions, readOnly, preDefValue, autoFocus, addOnWithButton } = props
  const iconRight = props.iconRight || (suggestions ? faCaretDown : undefined)
  const [fieldValue, fieldState, handleFieldChange, handleFieldBlur] = useForm(name)

  const [datalistId] = useState(`suggestion-list-${Math.random().toString(16).slice(2, 10)}`)
  const [listLoading, setListLoading] = useState(false)

  const [dropdownActive, setDropdownActive] = useState(false)

  const formatPhoneValue = val => val[0] !== '+' ? new AsYouType('US').input(val) : new AsYouType().input(val)

  useEffect(() => {
    if (preDefValue) handleFieldChange(name, preDefValue)
  }, []) // eslint-disable-line

  const handleOnBlur = ev => {
    setDropdownActive(false)

    const returnValue = phoneType ? formatPhoneValue(ev.target.value) : ev.target.value
    handleFieldBlur(name, returnValue)
    if (onBlur) onBlur(ev)
  }
  const handleOnChange = ev => setValue(ev.target.value, ev)
  const setValue = (value, ev) => {
    const returnValue = phoneType ? formatPhoneValue(value) : value
    handleFieldChange(name, returnValue)
    if (onChange) onChange(ev || { target: { value } })
  }

  const inputProperties = {
    type: type || 'text',
    disabled,
    required,
    className: classNames('input', { 'is-danger': fieldState.state === 'invalid' }, classes),
    placeholder,
    id,
    name: suggestions ? undefined : name,
    pattern,
    readOnly,
    autoFocus,
    value: fieldValue,
    list: suggestions ? datalistId : undefined,
    onChange: ev => handleOnChange(ev),
    onBlur: ev => handleOnBlur(ev),
    onFocus: ev => setDropdownActive(true)
  }

  let inputMarkup = (
    <>
      <input {...inputProperties} />
      {fieldState.state === 'invalid' && (<p className='help is-danger'>{fieldState.errorMsg}</p>)}
      {suggestions ? <SuggestionList {...{ suggestions, datalistId, listLoading, setListLoading }} /> : undefined}
    </>
  )

  if (label) {
    inputMarkup = (
      <div className='field'>
        <label className='label'>{label}</label>
        <div className={classNames('control', { 'is-loading': listLoading })}>
          <input {...inputProperties} />
        </div>
        {fieldState.state === 'invalid' && (<p className='help is-danger'>{fieldState.errorMsg}</p>)}
        {suggestions ? <SuggestionList {...{ suggestions, datalistId, listLoading, setListLoading }} /> : undefined}
      </div>
    )
  }

  if (iconLeft || iconRight) {
    const wrapperClasses = classNames('control', {
      'has-icons-left': iconLeft,
      'has-icons-right': iconRight,
      'is-loading': listLoading
    })
    inputMarkup = (
      <div className='field'>
        {label && <label className='label'>{label}</label>}
        <div className={wrapperClasses}>
          <input {...inputProperties} />
          {iconLeft && <span className='icon is-small is-left'>{iconLeft && (<span className='icon'><FontAwesomeIcon icon={iconLeft} /></span>)}</span>}
          {iconRight && <span className='icon is-small is-right'>{iconRight && (<span className='icon'><FontAwesomeIcon icon={iconRight} /></span>)}</span>}
        </div>
        {fieldState.state === 'invalid' && (<p className='help is-danger'>{fieldState.errorMsg}</p>)}
      </div>
    )
  }

  if (addOnWithButton) {
    const wrapperClasses = classNames('control', {
      'has-icons-left': iconLeft,
      'has-icons-right': iconRight,
      'is-loading': listLoading
    })
    inputMarkup = (
      <>
        {label && <label className='label'>{label}</label>}
        <div className='field has-addons'>
          <div className={wrapperClasses}>
            <input {...inputProperties} />
            {iconLeft && <span className='icon is-small is-left'>{iconLeft && (<span className='icon'><FontAwesomeIcon icon={iconLeft} /></span>)}</span>}
            {iconRight && <span className='icon is-small is-right'>{iconRight && (<span className='icon'><FontAwesomeIcon icon={iconRight} /></span>)}</span>}
          </div>
          <div className='control'>
            <Button onClick={addOnWithButton.handleOnClick}>{addOnWithButton.buttonText}</Button>
          </div>
          {fieldState.state === 'invalid' && (<p className='help is-danger'>{fieldState.errorMsg}</p>)}
        </div>
      </>
    )
  }

  if (suggestions) {
    inputMarkup = (
      <div className={classNames('dropdown is-width-100', { 'is-active': dropdownActive })}>
        <div className='dropdown-trigger is-width-100'>
          {inputMarkup}
        </div>
        <div className='dropdown-menu is-width-100'>
          <SuggestionList {...{ suggestions, listLoading, setListLoading, setValue }} />
        </div>
      </div>
    )
  }

  return inputMarkup
}

export default FormInputField
